import React from "react";
import {
  Create,
  FormDataConsumer,
  SelectInput,
  TextInput,
  BooleanInput,
  required,
  NumberInput,
  ReferenceInput,
  ImageInput,
  ImageField,
  TabbedForm,
  SimpleForm,
  FormTab,
  DateInput,AutocompleteInput
} from "react-admin";
import moment from "moment";
import { useStyles } from "../../formStyles";
import { CreateToolbar } from "../../CreateToolbar";

export const VendorCreate = (props) => {
  const classes = useStyles({});
  let defaultValues = {
    isActive:true
  };
  return (
    <Create title="Vendor Create" {...props}>

      <SimpleForm variant="outlined" redirect="list" toolbar={<CreateToolbar {...props} />} initialValues={defaultValues}>

        <TextInput source="code" label="Code" formClassName={classes.one_three_input} disabled={true}/>
        <TextInput source="name" label="Name" validate={[required()]} formClassName={classes.two_three_input} />
        <TextInput source="phoffice" label="Phone(Off)." formClassName={classes.last_three_input} />

        <TextInput source="email" label="email" formClassName={classes.one_three_input} />
        <TextInput source="phmobile" label="Mobile" formClassName={classes.two_three_input} />
        <TextInput source="gstNo" label="GST Number" formClassName={classes.last_three_input} />

        
        <TextInput source="panno" label="Pan Number" formClassName={classes.one_three_input} />
        <TextInput source="stateCode" label="State Code" formClassName={classes.two_three_input}  />
        <TextInput source="state" label="State" validate={[required()]} formClassName={classes.last_three_input} />

        <TextInput source="city" label="City" validate={[required()]} formClassName={classes.one_three_input} />
        <TextInput source="add1" label="Address 1" validate={[required()]} formClassName={classes.two_three_input} />
        <TextInput source="add2" label="Address 2" formClassName={classes.last_three_input} />

        <TextInput source="add3" label="Address 3" formClassName={classes.one_three_input} />
        <TextInput source="pincode" label="Pincode" validate={[required()]} formClassName={classes.two_three_input} />
        <TextInput source="cpName1" label="Contact Person 1" formClassName={classes.last_three_input} />

        <TextInput source="cpMob1" label="Contact Person 1 Mobile" formClassName={classes.one_three_input} />
        <TextInput source="cpRes1" label="Contact Person 1 ResiID" formClassName={classes.two_three_input} />
        <ReferenceInput label="Tax Type" perPage={5000} source="taxTypeId" filter={{ type: 'TT' }} reference="lookups" formClassName={classes.last_three_input}>
                    <SelectInput optionText="name"  />
          </ReferenceInput>

         <NumberInput  label="Tax Percentage"  source="taxPercentage"   formClassName={classes.one_three_input} /> 
        <ReferenceInput label="Area" source="areaId" reference="areas" perPage={20000}  sort={{ field: 'name', order: 'ASC' }} formClassName={classes.two_three_input} filterToQuery={searchText => ({ 'name~like': searchText })}>
        <AutocompleteInput optionText="name" shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }} />
           </ReferenceInput>
        <BooleanInput source="isActive" label="Active" initialValue={true} formClassName={classes.last_three_input} />

      </SimpleForm>


    </Create>
  );
};
